import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail, Heart } from "lucide-react";
import { CheetahDivider } from "./BrandAccents";
import NewsletterSignup from "./NewsletterSignup";

export default function Footer() {
  return (
    <footer className="relative bg-[#efe5d4] border-t border-[#e5dccd] mt-24 grunge-overlay">
      <div className="max-w-7xl mx-auto px-6 pt-16 pb-10 grid grid-cols-1 md:grid-cols-4 gap-10 relative">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <img src="/brand/logo.png" alt="Snip Happens" className="h-14 w-auto object-contain" />
            <div>
              <div className="font-display font-extrabold text-2xl text-[#1c1815]">Snip Happens</div>
              <div className="font-script text-2xl text-[#e8478e] -mt-1">Boutique</div>
            </div>
          </div>
          <p className="mt-5 text-sm text-[#4a4239] max-w-md leading-relaxed">
            Trendy designs. Boutique finds. You. Made for the babes who want their wardrobe — and their craft stash — to be a little louder.
          </p>
          <div className="mt-5 flex items-center gap-3">
            <a href="#" className="p-2.5 rounded-full bg-white border border-[#e5dccd] hover:bg-[#e8478e] hover:text-white hover:border-[#e8478e] transition-all" aria-label="Instagram"><Instagram size={16}/></a>
            <a href="#" className="p-2.5 rounded-full bg-white border border-[#e5dccd] hover:bg-[#2eb6a8] hover:text-white hover:border-[#2eb6a8] transition-all" aria-label="Facebook"><Facebook size={16}/></a>
            <a href="mailto:support@sniphappensboutique.com" className="p-2.5 rounded-full bg-white border border-[#e5dccd] hover:bg-[#9c6dde] hover:text-white hover:border-[#9c6dde] transition-all" aria-label="Email"><Mail size={16}/></a>
          </div>

          <div className="mt-8 p-5 rounded-2xl bg-white/70 border border-[#e5dccd] max-w-md">
            <NewsletterSignup variant="footer"/>
          </div>
        </div>

        <div>
          <div className="text-[10px] uppercase tracking-[0.3em] text-[#8a8076] mb-4 font-bold">Shop</div>
          <ul className="space-y-2.5 text-sm text-[#1c1815]">
            <li><Link to="/shop?category=digital" className="link-fancy hover:text-[#2eb6a8]">Digital Downloads</Link></li>
            <li><Link to="/shop?category=shirts" className="link-fancy hover:text-[#2eb6a8]">Shirts</Link></li>
            <li><Link to="/shop?category=crafts" className="link-fancy hover:text-[#2eb6a8]">Crafts</Link></li>
            <li><Link to="/shop" className="link-fancy hover:text-[#2eb6a8]">All Products</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-[10px] uppercase tracking-[0.3em] text-[#8a8076] mb-4 font-bold">Company</div>
          <ul className="space-y-2.5 text-sm text-[#1c1815]">
            <li><Link to="/about" className="link-fancy hover:text-[#e8478e]">About</Link></li>
            <li><Link to="/contact" className="link-fancy hover:text-[#e8478e]">Contact</Link></li>
            <li><Link to="/login" className="link-fancy hover:text-[#e8478e]">Account</Link></li>
          </ul>
        </div>
      </div>

      <CheetahDivider className="max-w-7xl mx-auto"/>

      <div className="px-6 py-6 text-xs text-[#8a8076] flex items-center justify-between max-w-7xl mx-auto flex-wrap gap-3">
        <div className="flex items-center gap-2">
          <Heart size={12} className="text-[#e8478e]" fill="currentColor"/>
          <span>© {new Date().getFullYear()} Snip Happens Boutique. All rights reserved.</span>
        </div>
        <div className="font-script text-base text-[#9c6dde]">Stay Sassy ✦</div>
      </div>
    </footer>
  );
}
